import React, { useEffect } from 'react';
import { Paper } from '@material-ui/core';

import loc from 'sources/locale/loc';
import useFieldChange from 'hooks/use-field-change';
import { Button, Form, TextField } from 'components/controls';
import withAuth from 'decorators/withAuth';
import styles from './LoginPage.scss';

function LoginPage(props) {
  const {
    onLogin,
    error,
    processing,
    currentUser,
    authorized,
    history,
  } = props;

  const { values, handleFieldChange } = useFieldChange({
    email: '',
    password: '',
  });

  const { email, password } = values;
  const handleLogin = () => {
    onLogin(email, password);
  };

  useEffect(() => {
    if (authorized) {
      const path = currentUser.role.getAfterLoginPath();
      history.push(path);
    }
  }, [authorized]);

  return (
    <Paper elevation={1} className={styles.loginFormContainer}>
      <h1>{loc('sign-in')}</h1>
      <Form
        onSubmit={handleLogin}
        processing={processing}
        error={error}
        onFieldChange={handleFieldChange}
        fieldValues={values}
      >
        <TextField
          label={loc('email')}
          fieldKey="email"
          className={styles.field}
        />
        <TextField
          type="password"
          label={loc('password')}
          className={styles.field}
          fieldKey="password"
        />
        <Button
          type="submit"
          variant="filled"
          color="primary"
          label={loc('submit')}
          className={styles.submitButton}
        />
      </Form>
    </Paper>
  );
}

export default withAuth(LoginPage);



// WEBPACK FOOTER //
// ./src/components/Auth/LoginPage.jsx